import { keyframes as t } from "@emotion/react";
const e = t({
  from: { opacity: 0, transform: "scale(0.7)" },
  to: { opacity: 1, transform: "scale(1)" }
}), n = {
  maxWidth: 70,
  px: (o) => o.spacing(2.5),
  py: (o) => o.spacing(0.5),
  bg: "primary",
  color: "white",
  borderRadius: "lg",
  fontSize: "xs",
  lineHeight: "label",
  userSelect: "none",
  zIndex: "dropdownMenu",
  "@media (prefers-reduced-motion: no-preference)": {
    animationDuration: "125ms",
    animationTimingFunction: "ease",
    transformOrigin: "var(--radix-tooltip-content-transform-origin)",
    willChange: "transform, opacity",
    '&[data-state="delayed-open"]': {
      animationName: e
    }
  }
}, a = {
  tooltip: n
};
export {
  n as tooltip,
  a as tooltipsTheme
};
